// ----------------------------------------------------------------------
// V2 Modern Avatar Styling

import { alpha } from '@mui/material/styles';

export default function Avatar(theme) {
  const primaryMain = '#7635dc';

  return {
    MuiAvatar: {
      styleOverrides: {
        root: {
          fontWeight: 700
        },
        colorDefault: {
          color: primaryMain,
          backgroundColor: alpha(primaryMain, 0.1)
        }
      }
    },
    MuiAvatarGroup: {
      styleOverrides: {
        avatar: {
          fontSize: 16,
          fontWeight: theme.typography.fontWeightBold,
          borderColor: theme.palette.background.paper,
          '&:first-of-type': {
            fontSize: 14,
            color: primaryMain,
            backgroundColor: alpha(primaryMain, 0.15)
          }
        }
      }
    }
  };
}
